import '../../../../cesis/js/cesis_custom.js'
import '../../../../cesis/js/cesis_collapse.js'
import '../../../../cesis/js/cesis_countup.js'
import '../../../../cesis/js/cesis_easing.js'
import '../../../../cesis/js/cesis_fittext.js'
import '../../../../cesis/js/fitvids.js'
import '../../../../cesis/js/fonticonpicker.js'
import '../../../../cesis/js/lightgallery.js'
import '../../../../cesis/js/owlcarousel.js'
// import '../../../../cesis/js/scrollmagic.js'
import '../../../../cesis/js/cesis_transition.js'
import '../../../../cesis/js/smartmenus.js'
import '../../../../cesis/js/isotope.js'
import '../../../../cesis/js/waypoints.js'

console.log('success')



// WEBPACK FOOTER //
// ./scripts/main.js